import config from "config";
import React from "react";
import apiRequest from "utils/ApiRequest/apiRequest.js";

export const exportFile = (inputFile) => {
  switch (inputFile.FileType) {
    case "txt":
      const element = document.createElement("a");
      const file = new Blob([inputFile.FileContent], {
        type: inputFile.FileContentType,
      });
      element.href = URL.createObjectURL(file);
      element.download = inputFile.FileName;
      element.click();
      break;
    case "csv":
      if (inputFile.FileContent) {
        let temp = "\ufeff";
        temp += inputFile.FileContent;
        const elementCsv = document.createElement("a");
        const fileCsv = new Blob([temp], {
          type: inputFile.FileContentType,
        });
        elementCsv.href = URL.createObjectURL(fileCsv);
        elementCsv.download = inputFile.FileName + ".csv";
        elementCsv.click();
      }
      break;
    case "xml":
      const elementXml = document.createElement("a");
      let temp = "\ufeff";
      temp += inputFile.FileContent;
      const fileXml = new Blob([temp], {
        type: inputFile.FileContentType,
      });
      elementXml.href = URL.createObjectURL(fileXml);
      elementXml.download = inputFile.FileName + ".xml";
      elementXml.click();
      break;
    default:
      break;
  }
};

const convertToDateCSharp = (date) => {
  var date = new Date(date);
  var day = date.getDate(); // yields date
  var month = date.getMonth() + 1; // yields month (add one as '.getMonth()' is zero indexed)
  //if month is less than 10 add 0 before month
  if (month < 10) {
    month = "0" + month;
  }
  //if day is less than 10 add 0 before day
  if (day < 10) {
    day = "0" + day;
  }
  var year = date.getFullYear(); // yields year
  // After this construct a string with the above results as below
  var time = day + "/" + month + "/" + year;
  return time;
};

export const exportMailsToFile = async (
  type,
  selectedFormArray,
  startDate,
  endDate,
  culture,
  setLoadingExports
) => {
  setLoadingExports(true);
  if (selectedFormArray.length > 1) {
    if (type === "excel") {
      multipleExportMailsToExcelFile(
        selectedFormArray,
        startDate,
        endDate,
        culture,
        setLoadingExports
      );
    } else {
      const parameters = {
        EmbedFormId: selectedFormArray,
        StartDate: convertToDateCSharp(startDate),
        EndDate: convertToDateCSharp(endDate),
        Type: type,
        Culture: culture,
      };
      const response = await apiRequest(
        "EmbedDynamics",
        "ExportMailsToFileMultiple",
        parameters
      );
      if (response.status === "success") {
        exportFile(response.data);
        setLoadingExports(false);
      } else {
        setLoadingExports(false);
      }
    }
  } else {
    if (type === "excel") {
      exportMailsToExcelFile(
        selectedFormArray,
        startDate,
        endDate,
        culture,
        setLoadingExports
      );
    } else {
      const body = {
        EmbedFormId: selectedFormArray[0],
        StartDate: startDate,
        EndDate: endDate,
        Type: type,
        Culture: culture,
      };
      const response = await apiRequest(
        "EmbedDynamics",
        "ExportMailsToFile",
        body,
        "POST"
      );
      if (response.status === "success") {
        exportFile(response.data);
        setLoadingExports(false);
      } else {
        setLoadingExports(false);
      }
    }
  }
};

const exportMailsToExcelFile = async (
  selectedFormArray,
  startDate,
  endDate,
  culture,
  setLoadingExports
) => {
  let apiRequestSrc =
    config.api.src +
    "/EmbedDynamics/ExportMailsToExcelFile?EmbedFormId=" +
    selectedFormArray[0] +
    "&StartDate=" +
    convertToDateCSharp(startDate) +
    "&EndDate=" +
    convertToDateCSharp(endDate) +
    "&Culture=" +
    culture;
  // const parameters = {
  //   EmbedFormId: selectedFormArray[0],
  //   StartDate: convertToDateCSharp(startDate),
  //   EndDate: convertToDateCSharp(endDate),
  //   Culture: culture,
  // };
  // const response = await apiRequest(
  //   "EmbedDynamics",
  //   "ExportMailsToExcelFile",
  //   parameters,
  // );
  //var request = new XMLHttpRequest();
  //request.open("GET", apiRequestSrc);
  setLoadingExports(false);

  window.location.href = apiRequestSrc;
};

const multipleExportMailsToExcelFile = async (
  selectedFormArray,
  startDate,
  endDate,
  culture,
  setLoadingExports
) => {
  let apiRequestSrc =
    config.api.src +
    "/EmbedDynamics/MultipleExportMailsToExcelFile?EmbedFormId=" +
    selectedFormArray +
    "&StartDate=" +
    convertToDateCSharp(startDate) +
    "&EndDate=" +
    convertToDateCSharp(endDate) +
    "&Culture=" +
    culture;
  // const parameters = {
  //   EmbedFormId: selectedFormArray,
  //   StartDate: convertToDateCSharp(startDate),
  //   EndDate: convertToDateCSharp(endDate),
  //   Culture: culture,
  // };
  // const response = await apiRequest(
  //   "EmbedDynamics",
  //   "MultipleExportMailsToExcelFile",
  //   parameters
  // );
  if (apiRequestSrc) {
    setLoadingExports(false);
    window.location.href = apiRequestSrc;
  }
};

const MultipleExportMailsToExcelFileTest = async (
  selectedFormArray,
  startDate,
  endDate,
  culture,
  setLoadingExports
) => {
  const parameters = {
    EmbedFormId: selectedFormArray,
    StartDate: convertToDateCSharp(startDate),
    EndDate: convertToDateCSharp(endDate),
    Culture: culture,
  };
  const response = await apiRequest(
    "EmbedDynamics",
    "MultipleExportMailsToExcelFileTest",
    parameters
  );
  if (response.status === "success") {
    setLoadingExports(false);
    console.log("res",response);
    //exportFile(response.data);
  }
};
